import * as themeSettingsClient from 'ContentData/api/ThemeSettings';
import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { THEME_SETTINGS_FETCH } from 'ContentData/actions/ActionTypes';
const fetchThemeSettingsAction = createGenericFetchAction(THEME_SETTINGS_FETCH, themeSettingsClient.fetchThemeSettings);
export const fetchThemeSettings = themePath => fetchThemeSettingsAction(themePath);